export var DATE_MODIFIERS = [
    function (date) { return date.setSeconds(0); },
    function (date) { return date.setMinutes(0); },
    function (date) { return date.setHours(0); },
    function (date) { return date.setDate(1); },
    function (date) { return date.setMonth(0); },
];
export var TIME_PRECISION_MODIFIERS = {
    minute: DATE_MODIFIERS.slice(0, 1),
    hour: DATE_MODIFIERS.slice(0, 2),
    day: DATE_MODIFIERS.slice(0, 3),
    week: DATE_MODIFIERS.slice(0, 3),
    month: DATE_MODIFIERS.slice(0, 4),
    year: DATE_MODIFIERS.slice(0, 5),
};
